"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHighcharts = _interopRequireDefault(require("react-highcharts"));

var _highchartsMore = _interopRequireDefault(require("highcharts/highcharts-more"));

var _lodash = require("lodash");

var _utils = require("../utils.js");

var _DataSeriesHeatmapLegend = _interopRequireDefault(require("../manipulate/heatmap-legend/DataSeriesHeatmapLegend"));

var _HighchartsAllowNegativeLog = _interopRequireDefault(require("./HighchartsAllowNegativeLog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(0, _highchartsMore["default"])(_reactHighcharts["default"].Highcharts);
// SUFFIX is added, then removed, to merge single points with quartiles, otherwise we’d end up with two series: one for
// scatter points and other for boxplots
var SUFFIX = " individual";
(0, _HighchartsAllowNegativeLog["default"])(_reactHighcharts["default"].Highcharts);

var expressionPlotConfig = function expressionPlotConfig(_ref) {
  var titleSuffix = _ref.titleSuffix,
      xAxisCategories = _ref.xAxisCategories,
      cutoff = _ref.config.cutoff,
      dataSeries = _ref.dataSeries;
  return {
    chart: {
      ignoreHiddenSeries: false,
      type: "boxplot",
      inverted: true,
      zoomType: "y",
      events: {
        load: function load() {
          //works apart from when you later take some series out with the menu http://jsfiddle.net/sza4odkz/1/
          this.series.forEach(function (series, ix, self) {
            if (series.type === "scatter") {
              var correspondingBoxplotSeries = self.find(function (otherSeries, otherIx) {
                return otherSeries.name === series.name.replace(SUFFIX, "") && otherIx !== ix;
              });

              if (correspondingBoxplotSeries) {
                series.data.forEach(function (point) {
                  point.x = correspondingBoxplotSeries.xAxis.toValue(correspondingBoxplotSeries.data[point.x].shapeArgs.x + correspondingBoxplotSeries.data[point.x].shapeArgs.width / 2 + correspondingBoxplotSeries.group.translateX + correspondingBoxplotSeries.data[point.x].stem.strokeWidth() % 2 / 2);
                });
              }
            }
          });
        }
      }
    },
    title: {
      text: "Expression per transcript \u2013 ".concat(titleSuffix)
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true
    },
    xAxis: {
      tickLength: 5,
      tickColor: "rgb(192, 192, 192)",
      lineColor: "rgb(192, 192, 192)",
      categories: xAxisCategories,
      labels: {
        style: {
          fontSize: "9px"
        }
      }
    },
    yAxis: {
      type: "logarithmic",
      plotLines: cutoff > 0.1 ? [{
        value: cutoff,
        dashStyle: "Dash",
        color: "#333333",
        width: 1,
        label: {
          text: "Cutoff: ".concat(cutoff),
          align: "left",
          style: {
            color: "gray"
          }
        }
      }] : [],
      title: {
        text: "Expression (TPM)"
      },
      min: 0.1
    },
    series: dataSeries,
    plotOptions: {
      column: {
        grouping: false,
        shadow: false
      },
      series: {
        animation: false,
        events: {
          legendItemClick: function legendItemClick(_ref2) {
            var _ref2$target = _ref2.target,
                thisSeriesName = _ref2$target.name,
                chart = _ref2$target.chart;
            chart.series.forEach(function (s) {
              return s.name.replace(SUFFIX, "") === thisSeriesName.replace(SUFFIX, "") && (s.visible ? s.hide() : s.show());
            });
            return false;
          }
        }
      },
      scatter: {
        marker: {
          symbol: "circle",
          states: {
            hover: {
              enabled: true
            }
          }
        },
        states: {
          hover: {
            marker: {
              enabled: false
            }
          }
        }
      }
    }
  };
};
/*
    color number 0 is used in BoxplotCanvas.js
    if there is only one transcript, use the same color
    otherwise use different colors (tries to be less misleading)
    */


var colorForSeries = function colorForSeries(rowIndex, total) {
  return _reactHighcharts["default"].Highcharts.getOptions().colors[total < 2 ? 0 : rowIndex + 1];
};

var boxPlotDataSeries = function boxPlotDataSeries(_ref3) {
  var rows = _ref3.rows;
  return rows.map(function (_ref4, rowIndex, self) {
    var id = _ref4.id,
        expressions = _ref4.expressions;
    return {
      name: id,
      color: colorForSeries(rowIndex, self.length),
      data: expressions.map(function (_ref5) {
        var stats = _ref5.stats;
        return stats ? [stats.min, stats.lower_quartile, stats.median, stats.upper_quartile, stats.max] : [];
      })
    };
  }).filter(function (e) {
    return e.data.length > 0;
  });
};

var scatterDataSeries = function scatterDataSeries(_ref6) {
  var rows = _ref6.rows;
  return rows.map(function (_ref7, rowIndex, self) {
    var id = _ref7.id,
        expressions = _ref7.expressions;
    return {
      type: "scatter",
      name: "".concat(id).concat(SUFFIX),
      color: colorForSeries(rowIndex, self.length),
      data: [].concat.apply([], expressions.map(function (_ref8, ix) {
        var values = _ref8.values;
        return values ? values.filter(function (_ref9) {
          var value = _ref9.value;
          return value > 0;
        }).map(function (_ref10) {
          var value = _ref10.value,
              id = _ref10.id,
              assays = _ref10.assays;
          return {
            x: ix,
            y: value,
            info: {
              id: id,
              assays: assays
            }
          };
        }) : [];
      })),
      marker: {
        lineWidth: 1
      },
      tooltip: {
        pointFormat: "Expression: {point.y} TPM <br/>Assay: {point.info.assays}"
      },
      showInLegend: false
    };
  });
};

var ExpressionChart = function ExpressionChart(_ref11) {
  var rows = _ref11.rows,
      xAxisCategories = _ref11.xAxisCategories,
      config = _ref11.config,
      titleSuffix = _ref11.titleSuffix;
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: "chart"
  }, rows.length && /*#__PURE__*/_react["default"].createElement(_reactHighcharts["default"], {
    config: expressionPlotConfig({
      titleSuffix: titleSuffix,
      config: config,
      xAxisCategories: xAxisCategories,
      dataSeries: [].concat(boxPlotDataSeries({
        rows: rows
      }))
    })
  }));
}; // See: BaselineExpressionPerBiologicalReplicate.dominanceAmongRelatedValues


var DATA_SERIES = {
  dominant: {
    key: "dominant",
    name: "Dominant",
    colour: "rgb(0, 0, 115)",
    on: true
  },
  ambiguous: {
    key: "ambiguous",
    name: "Ambiguous",
    colour: "rgb(0, 85, 225)",
    on: true
  },
  nonDominant: {
    key: "nonDominant",
    name: "Non-dominant",
    colour: "rgb(179, 218, 255)",
    on: true
  },
  // Not used; we plot missing values with plotBackgroundColor
  absent: {
    key: "absent"
  }
};

var dominanceHeatmapConfig = function dominanceHeatmapConfig(_ref12) {
  var titleSuffix = _ref12.titleSuffix,
      xAxisCategories = _ref12.xAxisCategories,
      yAxisCategories = _ref12.yAxisCategories,
      dataSeries = _ref12.dataSeries;
  return {
    chart: {
      type: "heatmap",
      inverted: true,
      plotBackgroundColor: "rgb(235, 235, 235)",
      // Colour for non-expressed transcripts (aka absent)
      plotBorderColor: "darkgray"
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    title: {
      text: "Dominant transcripts \u2013 ".concat(titleSuffix)
    },
    xAxis: {
      categories: xAxisCategories,
      // Force-display leading and trailing categories, even if they have no data
      min: 0,
      max: xAxisCategories.length - 1
    },
    yAxis: {
      categories: yAxisCategories,
      title: {
        text: ""
      }
    },
    color: "#000000",
    tooltip: {
      useHTML: true,
      padding: 0,
      formatter: function formatter() {
        var rowHead = function rowHead(a, b, c, d) {
          return "<tr><th>".concat(a, "</th><th>").concat(b, "</th><th>").concat(c, "</th><th>").concat(d, "</th></tr>");
        };

        var rowData = function rowData(a, b, c, d) {
          return "<tr><td>".concat(a, "</td><td>").concat(b, "</td><td>").concat(c, "</td><td>").concat(d, "</td></tr>");
        };

        return "<table style=\"margin-bottom: 0;\">" + "<thead>" + rowHead("Replicate", "Rel isoform usage", "Expression", "Dominant") + "</thead>" + "<tbody>" + this.point.info.map(function (v) {
          return rowData(v.replicate, "".concat(Math.round(v.fractionOfExpression * 1000) / 10, " %"), "".concat(v.value, " TPM"), v.isDominant);
        }).join("") + "</tbody>" + "</table>";
      }
    },
    series: dataSeries
  };
};

var assignDataSeries = function assignDataSeries(values) {
  if (!values) {
    return DATA_SERIES.absent.key;
  }

  return values.find(function (v) {
    return v.isDominant;
  }) ? values.every(function (v) {
    return v.isDominant;
  }) ? DATA_SERIES.dominant.key : DATA_SERIES.ambiguous.key : values.find(function (v) {
    return v.value;
  }) ? DATA_SERIES.nonDominant.key : DATA_SERIES.absent.key;
};

var DominantTranscriptsChart = function DominantTranscriptsChart(_ref13) {
  var titleSuffix = _ref13.titleSuffix,
      rows = _ref13.rows,
      xAxisCategories = _ref13.xAxisCategories;
  var yAxisCategories = rows.map(function (r) {
    return r.name;
  });
  var unrolledRows = [].concat.apply([], [].concat.apply([], rows.map(function (r, row_ix) {
    return r.expressions.map(function (expressionPerReplicate, column_ix) {
      return !expressionPerReplicate.values ? [] : expressionPerReplicate.values.map(function (replicate) {
        return {
          replicate: replicate.assays.join(", "),
          x: column_ix,
          value: replicate.value.expression_absolute_units,
          y: row_ix
        };
      });
    });
  })));
  var expressionFractionsPerReplicate = [].concat.apply([], (0, _utils.groupIntoPairs)(unrolledRows, function (o) {
    return JSON.stringify({
      assay_group: o.x,
      replicate: o.replicate
    });
  }).map(function (a) {
    var values = a[1].map(function (x) {
      return x.value;
    }).sort(function (a, b) {
      return b - a;
    });
    var total = (0, _lodash.sum)(values);
    var topValue = values[0];
    var secondValue = values[1];
    var topTranscriptIsDominant = topValue && (!secondValue || topValue > secondValue * 2);
    return a[1].map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        fractionOfExpression: x.value ? x.value / total : 0,
        isDominant: x.value === topValue && topTranscriptIsDominant
      });
    });
  }));
  var expressionPerAssayGroupAndTranscript = [].concat.apply([], (0, _utils.groupIntoPairs)(expressionFractionsPerReplicate, function (o) {
    return o.x;
  }).map(function (a) {
    var allReplicatesForThisAssayGroup = a[1].map(function (e) {
      return e.replicate;
    }).filter(function (e, ix, self) {
      return self.indexOf(e) === ix;
    }).sort();
    return (0, _utils.groupIntoPairs)(a[1], function (o) {
      return o.y;
    }).map(function (aa) {
      return {
        x: a[0],
        y: aa[0],
        series: assignDataSeries(aa[1]),
        info: allReplicatesForThisAssayGroup.map(function (replicate) {
          return aa[1].find(function (e) {
            return e.replicate === replicate;
          }) || {
            replicate: replicate,
            isDominant: false,
            value: 0,
            fractionOfExpression: 0
          };
        })
      };
    });
  }));
  var dataSeries = (0, _utils.groupIntoPairs)(expressionPerAssayGroupAndTranscript, function (o) {
    return o.series;
  }).map(function (a) {
    return {
      name: a[0],
      data: a[1].map(function (e) {
        return {
          x: +e.x,
          y: +e.y,
          value: (0, _lodash.meanBy)(e.info, "fractionOfExpression"),
          info: e.info
        };
      }),
      color: DATA_SERIES[a[0]].colour
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactHighcharts["default"], {
    config: dominanceHeatmapConfig({
      titleSuffix: titleSuffix,
      xAxisCategories: xAxisCategories,
      yAxisCategories: yAxisCategories,
      dataSeries: (0, _lodash.sortBy)(dataSeries, ".name").reverse()
    })
  }));
};

var Transcripts = function Transcripts(_ref14) {
  var keepOnlyTheseColumnIds = _ref14.keepOnlyTheseColumnIds,
      columnHeaders = _ref14.columnHeaders,
      rows = _ref14.rows,
      config = _ref14.config,
      titleSuffix = _ref14.titleSuffix;
  var ixs = columnHeaders.map(function (e, ix) {
    return [e, ix];
  }).filter(function (eix) {
    return keepOnlyTheseColumnIds.includes(eix[0].id);
  }).map(function (eix) {
    return eix[1];
  });
  var xAxisCategories = columnHeaders.filter(function (e, ix) {
    return ixs.includes(ix);
  }).map(function (_ref15) {
    var id = _ref15.id,
        name = _ref15.name;
    return name || id;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(ExpressionChart, {
    titleSuffix: titleSuffix,
    config: config,
    xAxisCategories: xAxisCategories,
    rows: rows.map(function (row) {
      return _objectSpread(_objectSpread({}, row), {}, {
        expressions: row.expressions.filter(function (e, ix) {
          return ixs.includes(ix);
        })
      });
    })
  }), false && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(DominantTranscriptsChart, {
    titleSuffix: titleSuffix,
    xAxisCategories: xAxisCategories,
    rows: rows
  }), /*#__PURE__*/_react["default"].createElement(_DataSeriesHeatmapLegend["default"], {
    legendItems: Object.keys(DATA_SERIES).map(function (key) {
      return DATA_SERIES[key];
    }).filter(function (o) {
      return o.name && o.colour;
    }),
    title: "Dominant: dominant in all samples.\nAmbiguous: dominant in some samples.\nNon-dominant: non-dominant in all samples.",
    missingValueColour: "rgb(235, 235, 235)",
    missingValueLabel: "Not expressed"
  })));
};

var _default = Transcripts;
exports["default"] = _default;